const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.userName,
  userInfo: state => state.user.userInfo,
  // userEmail: state => state.user.userName,
  // userAddress: state => state.user.userName,
  routerList: state => state.user.RouterList,
  roles: state => state.user.roles
}
export default getters
